import styled from 'styled-components';

const TextWithIcon = styled.div`
    text-align: center;
    margin-bottom: 40px;
`;

export default TextWithIcon;
